import { useQuery } from "@tanstack/react-query";
import v3ApiService from "@/client/services/api/clients/v3ApiClient";

export const useGetAuthToken = () =>
  useQuery(["authtoken"], () => v3ApiService.getAuthToken(), {
    staleTime: 100000,
  });
